export default __webpack_public_path__ + "static/media/timeline-small.827b7d42.mp4";